import type { CompetitionPoolDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getCompetitionPoolDetails(
  competitionId: string,
  stageId: string,
  poolId: string
): Promise<CompetitionPoolDetailed> {
  return requestApiJsonOrThrow<CompetitionPoolDetailed>(
    `admin/competitions/${competitionId}/competition-stages/${stageId}/competition-pools/${poolId}`
  )
}

export const competitionPoolDetailsQuery = (competitionId: string, stageId: string, poolId: string) => ({
  queryKey: ['competition', competitionId, 'stage', stageId, 'pool', poolId],
  queryFn: () => getCompetitionPoolDetails(competitionId, stageId, poolId),
})
